import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [CommonModule, TranslateModule, RouterModule]
})
export class NotificationComponent implements OnInit {

  constructor() { }

  @Input()
  labelTranslationTag: string;
  @Input()
  value: number;
  @Input()
  routerLink: string;
  @Input()
  queryParams: any;

  ngOnInit(): void {
  }
}
